// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IFieldStateType } from './IFieldStateType';
import {
    IFieldStateTypeFromJSON,
    IFieldStateTypeFromJSONTyped,
    IFieldStateTypeToJSON,
    IFieldStateTypeToJSONTyped,
} from './IFieldStateType';

/**
 * 
 * @export
 * @interface ICardProcessorInfoDto
 */
export interface ICardProcessorInfoDto {
    /**
     * 
     * @type {string}
     * @memberof ICardProcessorInfoDto
     */
    card_processor: string;
    /**
     * 
     * @type {IFieldStateType}
     * @memberof ICardProcessorInfoDto
     */
    card_processor_state?: IFieldStateType;
}



/**
 * Check if a given object implements the ICardProcessorInfoDto interface.
 */
export function instanceOfICardProcessorInfoDto(value: object): value is ICardProcessorInfoDto {
    if (!('card_processor' in value) || value['card_processor'] === undefined) return false;
    return true;
}

export function ICardProcessorInfoDtoFromJSON(json: any): ICardProcessorInfoDto {
    return ICardProcessorInfoDtoFromJSONTyped(json, false);
}

export function ICardProcessorInfoDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ICardProcessorInfoDto {
    if (json == null) {
        return json;
    }
    return {
        
        'card_processor': json['card_processor'],
        'card_processor_state': json['card_processor_state'] == null ? undefined : IFieldStateTypeFromJSON(json['card_processor_state']),
    };
}

export function ICardProcessorInfoDtoToJSON(json: any): ICardProcessorInfoDto {
    return ICardProcessorInfoDtoToJSONTyped(json, false);
}

export function ICardProcessorInfoDtoToJSONTyped(value?: ICardProcessorInfoDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'card_processor': value['card_processor'],
        'card_processor_state': IFieldStateTypeToJSON(value['card_processor_state']),
    };
}

